import { message } from 'antd';
import { takeLatest } from 'redux-saga/effects';
import { ProjectAPI } from 'api/project';
import { StoreActionProps } from 'data/core';
import {
  ProjectPhaseDatesActionPayload,
  updateProjectPhaseDatesAction,
} from 'data/projects/actions';
import { logger } from 'services';

function* updateProjectPhaseDates(
  action: StoreActionProps<ProjectPhaseDatesActionPayload>,
) {
  const { data, options } = action.payload;
  const { projectId, phaseId, startDate, dueDate } = data;

  try {
    const updatedPhase = yield ProjectAPI.updateProjectPhase(
      projectId,
      phaseId,
      {
        startDate,
        dueDate,
      },
      options?.isSync,
    );

    if (updatedPhase && options?.toggleUpdating) {
      options.toggleUpdating(false);
    }
  } catch (error) {
    message.error('There was an error processing your request.');
    logger.error('unable to update project phase', { error, data });
  }
}

export const watchUpdateProjectPhaseDatesSaga = function* (): Generator {
  yield takeLatest(updateProjectPhaseDatesAction.type, updateProjectPhaseDates);
};
